import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import Customershipping from './Customershipaddress';
import Customerbilling from './Customeraddress';
import AttachmentIcon from '@mui/icons-material/Attachment';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddVendorsbox from './AddVendors';
import Addproducts from './Addproducts';

let strCust=[{title:'Add Vendor',year:'0',rowindex:'-1'}];
let strProd=[{title:'Add Product',year:'0',rowindex:'-1'}];
const strProduct=[];
const strProductdeflt='';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});





export default class Addvendorbill extends Component {

  
  constructor(props) {
    super();
	
	 var strdob=new Date();
	 var month="";
	if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}

	
	
	this.state = {
		isicondisplay:true,businesssettingvalue:'',
		gm_name:'',gm_id:'',isdraft:false,
		previocn:'',vendbilid:'',pdid:'',prodrowindex:0,
		vb_contactname:'',vb_file:'',
		vb_purchaseorderno:'',
		vb_vendorbillno:'',
		vb_billingaddress1:'',
		vb_billingaddress2:'',
		vb_billingcity:'',
		vb_billingstate:'',
		vb_billingpincode:'',vb_id:0,
		vb_notes:'',vbid:'',
		open:false,grandtotal:"0.00",
	    description:'',ledgername:'',
		vendorarray:[],produserarray:[],
		pvdata:[],ledgerdata:[],
		vendorarrauto:[],prodarrauto:[],paybalamt:0,
		selectedproduct:[],veid:'',taxbrkupsarr:[],
		billdate:Date.now(),
		billdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		duedate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		duedate:Date.now(),showField:-1,newpcid:0,
		selectedvendorexchange:[],submitbtn:"Save",
		redirect:false,erropen:false,vendrtags:'',projectData:[],
		isviewmoredisplay:false,copyest:"0",
		
		errormessage:'',errortype:"error"
	}
		 this.onTagsVendorexchange = this.onTagsVendorexchange.bind(this);
		 this.updatProductParent = this.updatProductParent;
		
		     this.insertvendorParent = this.insertvendorParent;
  }
   myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
 
	   this.setState({[nam]: val});	    
   
}
	 insertvendorParent = (childData) => {
	 this.setState({ veid:childData});		  
	 
	//alert(localStorage.getItem("newcuid")) 
   this.onloadVendorbyid(childData);
	 
 }
  updatProductParent= (childData) => {
	 this.setState({ pdid:childData,},()=>{ this.onloadProductid(childData);});		  
	 
	//alert(localStorage.getItem("newcuid")) 

	 
 }
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }



componentWillMount() {
	
	document.title = "Isifol Account - Vendor Bills";

if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		   let strname="Vendor Bills";
		   
	 this.props.parentdasCallback(
            strname+"~"
        ); 

		this.ProjectBind();
      let search = window.location.href;
    let Vbid = this.getParameterByName('vbnid', search);
	   let potype = this.getParameterByName('potype', search);
	  
		   let copyest = this.getParameterByName('copy', search);
		  if(copyest!==null)
		{this.setState({copyest:copyest});
			
		}
		 if(potype!==null)
		{this.setState({copyest:"1"});
			
		}
				if(Vbid!==null)
		{
		this.VendorviremoreGetall(Vbid);
		
		this.setState({isviewmoredisplay:false,isicondisplay:true})
		}
		
		else{
			this.Usergetdata();   


		}
		this.GetBusinessSettingLedger();
	
 
		
		
}
  
  PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=8')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        		
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
  
  GetBusinessSettingLedger() {
  axios.get(localStorage.getItem("ISIurl") +'ajaxbusinesssetting.php?action=getall&bs_page=1&bs_cmp_id=' +localStorage.getItem('ISIcmpid') +'&bs_id=8')
  .then(resp => {
    if (resp.data.length > 0) {
		
	

 this.setState({ le_ledgername:resp.data[0]["bs_value"],
	 pvdata: [{"rowindex":this.state.newpcid,"pr_id":"","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":resp.data[0]["bs_value"],"qty":"","pr_costprice":"","pr_isdeleted":0,"projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: this.state.newpcid}],}); 
	  
 
    }
	this.GetTermsAndNotes();
	this.BusinessSetting(); 
  });
}



  
  
    onEntertitle= (firstrow) => event  => {

	 
let id=parseInt(firstrow)+1,prevrow=parseInt(this.state.pvdata.length)-1;

if(this.state.pvdata[prevrow].pr_description!=="")
{
	 this.setState({pvdata: this.state.pvdata.concat([{"rowindex":id,"pr_id":"0","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.le_ledgername,"qty":"1","pr_costprice":"0.00","pr_isdeleted":0,"projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: this.state.newpcid}]), selectedproduct:[]});
}		
		 
 }

GetTermsAndNotes(){


	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesestimate.php?action=gettermsandnotes&ao_id=13&cmp_id='+localStorage.getItem("ISIcmpid"))
     
  .then(resp => { 
 if (resp.data.length > 0) {
  let note = '', terms='';
   resp.data.forEach(item => {
        if (item.ao_id === "13") {
          note = item.ao_description;
		 
		  
        } 
      });
  
	this.setState({
		
		vb_notes:note,
		
	})
 }
   
  
  })
  
  
}


   getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

Paymentbalance() {
	
	 axios.get(localStorage.getItem("ISIurl") + 'ajaxvendorbill.php?action=balamtbyvendorid&vb_vendor=' + this.state.veid)
        .then(resp => {
			let strreturn=resp.data;
            if (strreturn!='') {
				 this.setState({paybalamt:resp.data});
			}
		});
}

VendorviremoreGetall(Vbid) {
    
    axios.get(localStorage.getItem("ISIurl") + 'ajaxvendorbill.php?action=getall&vb_cmp_id='+localStorage.getItem("ISIcmpid")+'&vb_id=' + Vbid)
        .then(resp => {
     
				
           const items = {
          title:resp.data[0].ve_contactname,
          year:resp.data[0].vb_vendor,
		  
	
		 
           
        }; 
		let strvalue=false;
		
	
		if(resp.data[0].vb_status==="1")
		{
			strvalue=true;
			
			
		}
                this.setState({
					vb_notes:resp.data[0].vb_notes,
					vb_id:resp.data[0].vb_id,
					vendbilid:resp.data[0].vb_vendor,
					veid:resp.data[0].vb_vendor,
					
					billdate1:resp.data[0].vb_billdate,
					billdate:resp.data[0].billdate,
					vb_vendorbillno:resp.data[0].vb_vendorbillno,
					vb_purchaseorderno:resp.data[0].vb_purchaseorderno,
					  selectedvendorexchange:items,
					duedate:resp.data[0].billduedate,
					duedate1:resp.data[0].vb_duedate,
					previocn:resp.data[0].vb_file,
				
                    isdraft:strvalue,
					 
					
                },()=>{
					
					let strname="";
		   
	 this.props.parentdasCallback(
           "Vendor Bills:"+resp.data[0].vb_purchaseorderno+"~"
        );

						
					
				});
			this.VendorProdcutGetall(Vbid)
			this.onloadVendorbyid(resp.data[0].vb_vendor);
				 
           
        });

}



VendorProdcutGetall(vbid){


	axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbillproduct.php?action=getall&vbp_vb_id='+vbid)
     
  .then(resp => { 
let oldOptionspvdata=[]; 

let newrow= {"rowindex":resp.data.length,"pr_id":"","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.le_ledgername,"qty":"","pr_costprice":"","pr_isdeleted":"0","projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: resp.data.length}
	

	
    if(resp.data.length>0){
		
			
			  oldOptionspvdata=resp.data
			  let index=0;
			  oldOptionspvdata.forEach(eachrep => {
				
					eachrep.rowindex=index;
					eachrep.prodsel={"title":eachrep.pr_description,"year":eachrep.pr_id};
index++;
				});
		
		}	

	  this.setState({pvdata: oldOptionspvdata.concat([newrow])},()=>{this.Taxcalculate();
	  
	 
	  });
   this.ledgerbind(); 
  
    });
	
}

    Usergetdata() {
	 
	
	   this.setState({ 
	 pvdata: [{"rowindex":this.state.newpcid,"pr_id":"","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":"","qty":"","pr_costprice":"","pr_isdeleted":"0","projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: this.state.newpcid}],}); 
	  
 this.ledgerbind(); 
 this.ProjectBind()

	 
	 
 }
 
 
    ledgerbind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_isexpenses=1&sorting=le_id')
    
      .then((resp) => {   
	  
	  let LedgerApi = resp.data.map(row => {
                      
          return {value: row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		
		 this.setState({
          ledgerdata: LedgerApi
        });
      })
	
}

	
	 ProjectBind(){

        axios.get(localStorage.getItem("ISIurl") + 'ajaxgroupmaster.php?action=getall&gm_type=2&gm_cmp_id='+localStorage.getItem("ISIcmpid"))
    
      .then((resp) => {   
	  
	  let groupAPi = resp.data.map(row => {
                      
          return {value: row.gm_id, display:row.gm_name}
        });
		
		 this.setState({
			  projectData: [{value:'0', display:'None'}].concat(groupAPi)
       
        },()=>{
			
		
		});
      })
	
} 
	
onloadProductid(pdid){
	
	let discal=0,strdisamt=0,costdiscnt=0;
	let id=this.state.prodrowindex;
	if(pdid!="")
	{
	axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=productautoextender&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_id='+pdid)
  .then(resp => {  
   if(resp.data.length>0){
   const items = {
        title:resp.data[0]["title"]+" ("+resp.data[0]["pr_code"]+")",
          year:resp.data[0].year,
		 
           
        };
		
		let optionsRep = this.state.pvdata;
		 optionsRep.sort((a, b) => a.rowindex > b.rowindex ? 1 : -1).forEach(eachrep => {
		
       if (eachrep.rowindex === id)
	   {
		   
	  let strcostamount=(parseFloat( resp.data[0]["pr_costprice"])*Number(1));
	
			     eachrep.pr_code=  resp.data[0]["pr_code"];
			   eachrep.pr_description=  resp.data[0]["pr_description"];
		    
			   
			 
			    eachrep.pr_costprice= parseFloat( resp.data[0]["pr_costprice"]).toFixed(2);
			 
		      
			 
		       eachrep.le_ledgername= resp.data[0]["ledgername"];
			   
			   eachrep.projectgroup_id="0";
		       eachrep.qty= "1"; 
			   
			   eachrep.pr_id= resp.data[0]["pr_id"];
			   eachrep.esprodid= resp.data[0]["pr_id"];
			  
		    eachrep.pr_isdeleted= "0";
			
			 eachrep.prodsel=  resp.data[0];

		     
		   eachrep.total= parseFloat(strcostamount).toFixed(2);
		   
	   }
	   
		 });
		 	id=parseFloat(id)+1;
	
 
this.setState({pvdata: optionsRep.concat([{"rowindex":id,"pr_id":"","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":"","qty":"","pr_costprice":"","pr_isdeleted":"0","projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: id}]), selectedproduct:items},()=>{
		this.Taxcalculate();
	},()=>{
		
		
	})
   }
  });
	}
}
onloadVendorbyid(veid){
	
		 axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=getall&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&ve_id='+veid)
  .then(resp => {  
   if(resp.data.length>0){
    this.setState({ 
		
	    veid:resp.data[0].ve_id,
		vb_billingaddress1:resp.data[0].ve_billingaddress1,
		vb_billingaddress2:resp.data[0].ve_billingaddress2,
		vb_billingcity:resp.data[0].ve_billingcity,
		vb_billingstate:resp.data[0].ve_billingstate,
		vb_billingpincode:resp.data[0].ve_billingpincode,
  
	},()=>{this.Paymentbalance();});

   }
   
  });

}   


  onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({vendbilid:newTextValue},()=>{})
	} 
}
  
onTagsVendorexchange = (event, values) => {
	

	if(values!==" " && values!==null && values.rowindex!=="-1"){
		this.setState({
		
		veid:values.year,
	
		  vb_billingaddress1:values["ve_billingaddress1"],
		vb_billingaddress2:values["ve_billingaddress2"],
		vb_billingcity:values["ve_billingcity"],
		vb_billingstate:values["ve_billingstate"],
		vb_billingpincode:values["ve_billingpincode"],
		selectedvendorexchange:values})
		
	}
	
	else
	{
		 this.setState({veid:'',selectedvendorexchange:[]})
	}
	
}
onloadVendorBind=(event)=>{

	 axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=vendorextender&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&ve_contactname='+event.target.value)
  .then(resp => { 
  this.setState({vendorarray:resp.data},()=>{
	  
	   var rowsArray = this.state.vendorarray;
	 rowsArray.map((row, i) => {
			 
		 const items = {
         title:row.title,
         year:row.year,
		
		
		
		 rowindex:row.rowindex,
         ve_contactname:row.ve_contactname,
		 
		ve_billingaddress1:row["ve_billingaddress1"],
		ve_billingaddress2:row.ve_billingaddress2,
		ve_billingcity:row.ve_billingcity,
		ve_billingstate:row.ve_billingstate,
		ve_billingpincode:row.ve_billingpincode,
		
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	
		  this.setState({vendorarrauto:strCust})
	  
	  
  });

	
  });
	 
	
}

	

  	

  
  
  
  
  handlevendorbilldate = (date) => {
  let businessSetting = this.state.businesssettingvalue;
  let invDate = new Date(date);
  let dueDate = new Date(invDate);

  if (businessSetting === 1) {
    dueDate.setDate(invDate.getDate() + 3);
  } else if (businessSetting === 2) {
    dueDate = new Date(invDate.getFullYear(), invDate.getMonth() + 1, 0);
  } else if (businessSetting === 3) {
    dueDate = new Date(invDate);
  }

  this.setState({
    billdate: dayjs(invDate),
    billdatee1: invDate.getFullYear() + "-" + String(invDate.getMonth() + 1).padStart(2,"0") + "-" + invDate.getDate(),
    duedate: dayjs(dueDate),
    duedate1: dueDate.getFullYear() + "-" + String(dueDate.getMonth() + 1).padStart(2,"0") + "-" + dueDate.getDate()
  });
};

handleduedate = (date) => {
  let dueDate = new Date(date);
  this.setState({
    duedate: dayjs(dueDate),
    duedate1: dueDate.getFullYear() + "-" + String(dueDate.getMonth() + 1).padStart(2,"0") + "-" + dueDate.getDate()
  });
};
  
  

onloadProductsBind=(event)=>{

	 if(event.target.value.length>0 ){
 axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=productautoextender&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_code='+event.target.value+'&defaultprice=4')
  .then(resp => { 
  
  if(resp.data.length>0){
  this.setState({ produserarray:resp.data });
   var rowsArrayp = resp.data;
 
	 rowsArrayp.map((row, j) => {
		
		 
		 const items = {
			 
        title:row.title+" ("+row.pr_code+")",
          year:row.year,rowindex:row.rowindex,
           pr_code:row.pr_code, 
		   pr_description:row.pr_description,
		  ledgername:row.pr_ledger_id,
		   pr_tax_id:row.pr_tax_id,
		  quantity:row.pr_quantity,
          salesprice:row.price,
		  pr_costprice:row.pr_costprice,
		  taxper:row.dwt_percentage
        };
      const found = strProd.some(el => el.year === row.year);
		 if (!found) strProd.push(items);
	 
		 });
		   this.setState({prodarrauto:strProd})
  } 
  
  
  });
 
  }
}


 onInputprodChange = (rows) =>(event, newTextValue) => {

if(newTextValue!==" "){

	
	const updatedArray = [...this.state.pvdata];
	
	updatedArray[rows].esprodid = newTextValue;
  this.setState({pvdata:updatedArray})
}  
 }
 onTagsproductChange =(index) => (event, values) => {	
	 let discal=0,strdisamt=0,costdiscnt=0;

	 let id = index;

	if(values.rowindex!=="-1")
	{
	let optionsRep = this.state.pvdata;
   optionsRep.sort((a, b) => a.rowindex > b.rowindex ? 1 : -1).forEach(eachrep => {
		
       if (eachrep.rowindex === id)
	   {
		


  let strcostamount=(parseFloat( values["pr_costprice"])*Number(1));
 

	
			   eachrep.pr_code= values["pr_code"];
			   eachrep.pr_description= values["pr_description"];
		    
			   
			 
			    eachrep.pr_costprice= parseFloat(values["pr_costprice"]).toFixed(2);
			 
		      
			 
		       eachrep.le_ledgername=this.state.le_ledgername;
			   
			   eachrep.projectgroup_id=values["project"];
		       eachrep.qty= "1"; 
			   
			   eachrep.pr_id=values["year"];
			   eachrep.esprodid=values["year"];
			  
		    eachrep.pr_isdeleted= "0";
			
			 eachrep.prodsel= values;

		     
		   eachrep.total= parseFloat(strcostamount).toFixed(2);
		 
			
	
	}
	   
	  
    })
	id=parseFloat(id)+1;
	
 
this.setState({pvdata: optionsRep.concat([{"rowindex":id,"pr_id":"","vbp_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.le_ledgername,"qty":"","pr_costprice":"","pr_isdeleted":"0","projectgroup_id":"","project":"0","projectisopne":"0","prodsel":[],"prodtax":[],	"total":"0.00",showField: id}]), selectedproduct:values},()=>{
		this.Taxcalculate();
		this.ProjectBind();
	})	



	}	
  }

 myChangeHandlerPV = (firstrow) => event  => { 
	
		const re = /^[0-9.\b]+$/;
   let nam = event.target.name;
  let val = event.target.value;
  
   let optionsRep = this.state.pvdata;
  
  let strtotaldiscount="0";
  
  
  let id = this.state.showField;
  
  const updatedArray = [...this.state.pvdata];
if(nam==="pr_description")
		   {

		updatedArray[firstrow].pr_description = val;
		if(updatedArray[firstrow].pr_id=="")
		{
			updatedArray[firstrow].pr_id = "0";
		}
  
		   }
if(nam==="le_ledgername") {
updatedArray[firstrow].le_ledgername = val;
}
if(nam==="qty") {
updatedArray[firstrow].qty = val;
  	
}

if(nam==="pr_costprice") {
	if (event.target.value === '' || re.test(event.target.value)) {
	updatedArray[firstrow].pr_costprice = val;
	
	}

}

if(nam==="projectgroup_id") {
	

	updatedArray[firstrow].projectgroup_id = val;
	
}

let stramount=(parseFloat(updatedArray[firstrow].pr_costprice)*parseFloat(updatedArray[firstrow].qty));

 updatedArray[firstrow].total = parseFloat(stramount).toFixed(2);

  this.setState({pvdata: updatedArray},()=>{
	
	 console.log(updatedArray)
		  this.Taxcalculate();
	 
	  });
  


}
Taxcalculate(){
	
	let optionstaxRep = this.state.pvdata;
	
	let  strgrantotal=0;
	

    optionstaxRep.forEach(eachrep => {
		
		  if( eachrep.pr_isdeleted !== "1" && eachrep.pr_id !== "" ){
			strgrantotal=parseFloat(strgrantotal)+parseFloat(eachrep.total);
			
		  }
	},()=>{
		
		
		
	});

	 this.setState({grandtotal:parseFloat(strgrantotal).toFixed(2)},()=>{});
}



OnrowViewmore(prid,rowindex){

	

	
	const updatedArray = [...this.state.pvdata]; 
	
		if(updatedArray[rowindex].pr_id==="")
	{
		this.setState({errormessage:"Please Select products",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		
	}
	
	if(updatedArray[rowindex].pr_id!=="" && updatedArray[rowindex].projectisopne==="0")
			{				
			 	
				updatedArray[rowindex].projectisopne="1";
				alert(updatedArray[rowindex].projectisopne)
			
			}else if(updatedArray[rowindex].pr_id!=="" && updatedArray[rowindex].projectisopne==="1")
			{
				updatedArray[rowindex].projectisopne="0";
			}
	this.setState({pvdata:updatedArray});
		
}

onRowdelete(prid,rowindex){
	
	
	let r = window.confirm("Are you sure to Delete?");
		 if(r == true){
			const updatedArray = [...this.state.pvdata]; 
			
			
			
			if(updatedArray[rowindex].pr_id!=="")
			{				
			 updatedArray[rowindex].pr_isdeleted = "1";	
			  this.setState({pvdata: updatedArray,},()=>{this.Taxcalculate();console.log('pvdata afterdelete',this.state.pvdata);});
			}else{
				alert("You can not delete this row");
				return false;
			}
		 }
	
	
}




 onFileChange=(e) =>{
  let imageFile = e.target.files[0];
  this.setState({ vb_file: e.target.files })
	 	  
  if (!imageFile.name.match(/\.(png|jpeg|jpg|pdf)$/)) {

  this.setState({errormessage:"Please Upload Valid file (png,jpeg,jpg,pdf).",open:true});
		 window.scrollTo({        top: 0     })
	
  
    return false;
  }else{
        this.setState({ vb_file: e.target.files },()=>{
		
		
  })
  }
  
		
    }


onClickSalesSave= (event) => {
	
	
	
	
	let vb_id=this.state.vb_id;
	let vb_file=this.state.vb_file;
	let optionsVal = this.state.pvdata;
	
	
	let sep1="",strdraft="2";
	let optionValues="";
	let index=0;
	
	
	
	
	
		let strtotal=parseFloat(this.state.paybalamt)+parseFloat(this.state.grandtotal);
	

	
	
		var srearray=optionsVal.filter(value => value.op_isdeleted  < 1)
		 if(this.state.veid === "")
	 {		 
		 this.setState({errormessage:"Please Select Vendor",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 
	 	 if(this.state.billdate1 === "")
	 {		 
		 this.setState({errormessage:"Please Select Bill Date",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 
	 
	 if(this.state.duedate1 === "")
	 {		 
		 this.setState({errormessage:"Please Select Due Date",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 
	 
	
	 	 if(this.state.vb_vendorbillno === "")
	 {		 
		 this.setState({errormessage:"Please Enter VendorBill Number",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 
	 
	 	 if(this.state.vb_purchaseorderno === "")
	 {		 
		 this.setState({errormessage:"Please Enter Purchaseorder Number",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 
	
	 
	 
let optionisdeledValues="";
let sep2="";
	 
	  optionsVal.forEach(eachval => {
     
	  
		 if(eachval.pr_id!="" && eachval.pr_description!==""){  
	   if(eachval.pr_isdeleted==="1" )
	   {
		 optionisdeledValues=optionisdeledValues+sep2+eachval.vbp_id;
		 sep2=","
		
		   
	   }
	   else  if(eachval.pr_id!=="" && eachval.pr_description!=="" )
	   {
      

 optionValues=optionValues+sep1+eachval.pr_id+"~"+eachval.pr_description+"~"+eachval.le_ledgername+"~"+eachval.qty+"~"+eachval.pr_costprice+"~"+eachval.total+"~"+eachval.project+"~"+eachval.vbp_id;
 sep1="`"; 
	   }
		 }
		   
	 
    })
	
	
this.setState({btndisabled:true,submitbtn:"Processing..."})
		 
var formData = new FormData();
formData.append('action','insertorupdate')

   if(vb_file)
	  {
		
		for (const key of Object.keys(this.state.vb_file)) {
            formData.append('Filedata', this.state.vb_file[key])
        }
 	
	   formData.append('vb_file','1')		
	  }else
	  {
		 formData.append('vb_file',this.state.previocn)	  
	  
	  }



  
	 if(this.state.copyest==="1"){
	 
	 formData.append('vb_id',0) 
					}

else
					{
formData.append('vb_id',vb_id) 
					}
					
		
		if(this.state.isdraft===true)
		{
			strdraft="1";
		}
		
	formData.append('vb_vendor',this.state.veid) 			
	formData.append('vb_billdate',this.state.billdate1) 			
	formData.append('vb_duedate',this.state.duedate1) 			
	formData.append('vb_vendorbillno',this.state.vb_vendorbillno) 			
	formData.append('vb_purchaseorderno',this.state.vb_purchaseorderno) 			
	formData.append('vb_billingaddress1',this.state.vb_billingaddress1) 			
	formData.append('vb_billingaddress2',this.state.vb_billingaddress2) 			
	formData.append('vb_billingcity',this.state.vb_billingcity) 			
	formData.append('vb_billingstate',this.state.vb_billingstate) 			
	formData.append('vb_billingpincode',this.state.vb_billingpincode) 			
	formData.append('vb_notes',this.state.vb_notes) 			
	formData.append('vb_status',strdraft) 			
	formData.append('paymentbalamt',strtotal)
	formData.append('vb_cmp_id',localStorage.getItem("ISIcmpid"))
    formData.append('userid',localStorage.getItem("ISIuserid"))	
    formData.append('vendorbillproducts',optionValues)	
		formData.append('vb_type',1)
	
	if(optionisdeledValues!=="")
	{
    formData.append('vbpisdeleted',optionisdeledValues)	
	}
	else
	{
		
		 formData.append('vbpisdeleted',"")	
	}
			 axios.post(localStorage.getItem("ISIurl")+"ajaxvendorbill.php", formData, {
        })	
.then(res => {
	
	var strreturn=res.data;
			if(strreturn!==-1)
			{
			if(this.state.vb_id===0)
			{
			
				this.setState({btndisabled:false,submitbtn:"Save",errortype:"success",errormessage:"Vendor Bill created Successfully",erropen:true,veid:"",pvdata:[],vb_vendorbillno:'',vb_purchaseorderno:'',vendbilid:'',vb_notes:''})
			
			}
			
			
			  else if(this.state.copyest==="1")
			{
			
				this.setState({btndisabled:false,submitbtn:"Save",errortype:"success",errormessage:"Vendor Bill created Successfully",erropen:true,veid:"",pvdata:[],vb_vendorbillno:'',vb_purchaseorderno:'',vendbilid:'',vb_notes:''})
			
			}
	 
	 	else{
			
						this.setState({redirect:true,pagename:'/Adminvendorbills'});
							

				
			}
			}else{
				this.setState({errormessage:"Vendor Credit Limit Exceeds",errortype:"error",erropen:true,});
			}
			
			
				
				
				
				
				this.Usergetdata();this.Taxcalculate();
});
	
	
}

 handledraft=(e)=>{
	this.setState({isdraft: !this.state.isdraft},()=>{
		
		
	}); 
 }
 

 
 
 

 
 
 
 
  
 handlAddProductopen = (val) => {
	  this.setState({ prodrowindex: val },()=>{ this.refs.Addproducts.handleProdClose();    });  
	 
        

}
handleVendorInsertpopup= (e) => {
	  this.setState({ cuid: 0 },()=>{this.refs.AddVendorsbox.handlevendorClickOpen()});  
	
}




BusinessSetting() {
  axios.get(
    localStorage.getItem("ISIurl") +
      'ajaxbusinesssetting.php?action=getall&bs_page=1&bs_cmp_id=' +
      localStorage.getItem('ISIcmpid') +
      '&bs_id=6'
  ).then(resp => {
    if (resp.data.length > 0) {
      let settingValue = String(resp.data[0]["bs_value"] || ""); // keep string
      this.setState({ businesssettingvalue: settingValue });

      let today = new Date();
      let invDate = new Date(today);
      let dueDate = new Date(today);

      // split
      let parts = settingValue.split(",");
      let type = parts[0]; // "1" / "2" / "3"
      let days = parseInt(parts[1] || "0");

      if (type === "1") {
        dueDate.setDate(today.getDate() + (days > 0 ? days : 3));
      } else if (type === "2") {
        dueDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      } else if (type === "3") {
        dueDate = new Date(today);
      }

      this.setState({
        billdate: dayjs(invDate),
        billdate1:
          invDate.getFullYear() +
          "-" +
          String(invDate.getMonth() + 1).padStart(2, "0") +
          "-" +
          invDate.getDate(),
        duedate: dayjs(dueDate),
        duedate1:
          dueDate.getFullYear() +
          "-" +
          String(dueDate.getMonth() + 1).padStart(2, "0") +
          "-" +
          dueDate.getDate()
      });
    }
  });
}

handlevendorbilldate = (date) => {
  let settingValue = String(this.state.businesssettingvalue || "");
  let invDate = new Date(date);
  let dueDate = new Date(invDate);

  let parts = settingValue.split(",");
  let type = parts[0]; 
  let days = parseInt(parts[1] || "0");

  if (type === "1") {
    dueDate.setDate(invDate.getDate() + (days > 0 ? days : 3));
  } else if (type === "2") {
    dueDate = new Date(invDate.getFullYear(), invDate.getMonth() + 1, 0);
  } else if (type === "3") {
    dueDate = new Date(invDate);
  }

  this.setState({
    billdate: dayjs(invDate),
    billdate1:
      invDate.getFullYear() +
      "-" +
      String(invDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      invDate.getDate(),
    duedate: dayjs(dueDate),
    duedate1:
      dueDate.getFullYear() +
      "-" +
      String(dueDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      dueDate.getDate()
  });
};

handleduedate = (date) => {
  let dueDate = new Date(date);
  this.setState({
    duedate: dayjs(dueDate),
    duedate1:
      dueDate.getFullYear() +
      "-" +
      String(dueDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      dueDate.getDate()
  });
};

 onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/Adminvendorbills'});
 }

  
  render() { 
   let search = window.location.href;

	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  return(
  		<React.Fragment> 
		<div className="contenttext">
		 
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
		
		
		 
		<ul>
		<li>
		<p><span className="validation">*</span>Vendor</p>
		<p>
    <Autocomplete
      id="free-solo-demo"
      
      className="txtbox" 
	  inputValue={this.state.vendbilid}
      options={this.state.vendorarrauto}   
	  onInputChange={this.onInputCustChange}
	  onChange={this.onTagsVendorexchange} 
	  value={this.state.selectedvendorexchange}
      renderInput={(params) => ( 
        <TextField  placeholder="Search for a vendor" {...params} className="txtbox" onChange={this.onloadVendorBind}  variant="outlined" />
      )}
     getOptionLabel={(option) => option.title || ""}
      renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
         
				
              </tr> )}
			   {option.rowindex=="-1" &&(
			    <tr {...props}>
                <td width='10%' onClick={this.handleVendorInsertpopup}><span className='addautoextender' ><AddIcon />{option.title}</span></td>
         
				
              </tr>
			   )}
			  
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
	</p>
	<AddVendorsbox ref="AddVendorsbox" id={0}  updatevendor={this.insertvendorParent}/>
</li>
<li>  <p><span className="validation">*</span>Bill Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.billdate) }
      className="txtbox" 
	  Name="billdate"
      onChange={this.handlevendorbilldate} format="MM/DD/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p>

</li>
<li><p><span className="validation">*</span>Due Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.duedate) }
	 
	  minDate={dayjs(this.state.duedate)}
      className="txtbox"  inputProps={{tabIndex: "3"}}
      onChange={this.handleduedate} format="MM/DD/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p></li>



<li>  
		<p>Vendor Reference</p>
		<p>
		  <TextField 
            variant="outlined"
            margin="normal"
           
            fullWidth
			value={this.state.vb_vendorbillno}
            id="vb_vendorbillno"
           className="txtbox"
            name="vb_vendorbillno" onChange={this.myChangeHandler}
            placeholder="eg  Vendor's Bill Number"
            
			
          /></p></li>
		  
		  
<li> <p>Reference</p>
		<p> <TextField 
            variant="outlined"
            margin="normal"
           
            fullWidth
			value={this.state.vb_purchaseorderno}
            id="vb_purchaseorderno"
          className="txtbox"
            name="vb_purchaseorderno" onChange={this.myChangeHandler}
            placeholder="eg  Purchase Order Number"
            
			
          /></p></li>

</ul>
</div>



<div className="ordtbl">
<Paper >
 <TableContainer >  
 <Table stickyHeader aria-label="sticky table"> 
 
 <TableHead> 
<TableRow>
  <TableCell width="5%"></TableCell> 	
  <TableCell width="15%"><b>Product/Service</b></TableCell>     
  <TableCell width="20%"><b>Item Descriptions</b></TableCell>  
  <TableCell width="10%"><b>Ledger Name</b></TableCell> 
 <TableCell width="5%"><b>Qty</b></TableCell>  
  <TableCell width="10%"><b>Price</b></TableCell>   

   <TableCell width="10%"><b>Total</b></TableCell> 
		
   <TableCell width="5%"><b></b></TableCell> 			 			
                      </TableRow></TableHead>

		   
               
                      <TableBody>
					  
 {(this.state.pvdata).map((item,index) => {


				
           return ( <React.Fragment>
		   
	
		   
		   
		   {item.pr_isdeleted!=="1" && (	 
 <TableRow key={index} >



<TableCell align="right">


  {item.pr_id!=="" && (
 

 <Tooltip title="Delete">
 <IconButton aria-label="Delete">
  <div className="secondary">

 <DeleteIcon onClick={()=>{this.onRowdelete(item.pr_id,index)}}/>
 </div>
 </IconButton>
 </Tooltip>
  )}

 </TableCell>


<TableCell>
<p><Autocomplete
      id="free-solo-demo"
       className="txtbox"
     
	inputValue={item.esprodid}
		   onInputChange={this.onInputprodChange(index)}
		   onChange={this.onTagsproductChange(index)} 
	    value={item.prodsel}
      options={this.state.prodarrauto}
	   
      renderInput={(params) => (
        <TextField {...params} onChange={this.onloadProductsBind}  variant="outlined" />
      )}
      getOptionLabel={(option) => option.title || ""}
renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
         
				
              </tr> )}
			   {option.rowindex=="-1" &&(
			    <tr {...props}>
                <td width='10%' onClick={this.handlAddProductopen}><span className='addautoextender' ><AddIcon />{option.title}</span></td>
         
				
              </tr>
			   )}
			  
            </tbody>
          </table>
        </React.Fragment>
      )}
    /></p>
   
 
 

 
 </TableCell>  
 
 
          
 
  
<TableCell>

< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.pr_description}
            id="description"
           onBlur={this.onEntertitle(index)}
			//type="number"
            name="pr_description"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength:150
  }}
			
		 />
 

</TableCell>   

<TableCell>



<FormControl   className="txtbox">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		
         onChange={this.myChangeHandlerPV(index)}
          id="le_ledgername"
		   value={item.le_ledgername} className="txtbox"
		  name="le_ledgername"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.ledgerdata.map(ledger => (
            <option  
            
              value={ledger.value}
            >
              {ledger.display}
            </option  >
          ))}
		
        </Select></FormControl>
		


</TableCell>   

<TableCell>


< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.qty}
            id="qty"
           
			inputRef={element => (this.textRef = element)}
            name="qty"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
			
		 />
		



 
 

</TableCell>  

<TableCell>

  <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={item.pr_costprice}
            id="pr_costprice"          
            name="pr_costprice" onChange={this.myChangeHandlerPV(index)}
            autoComplete="price" inputProps={{
    maxLength: 6
  }}/>

</TableCell> 
 


<TableCell>
 

 
 

   <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={item.total}
            id="taxval"          
            name="taxval" 
            autoComplete="taxval"/>	 
 

</TableCell> 



<TableCell> 
{ item.projectisopne==="0" &&(
 <MoreVertIcon onClick={()=>{this.OnrowViewmore(item.pr_id,index)}} />
)}

{item.projectisopne==="1" &&(
<FormControl   className="txtbox">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		 
          onChange={this.myChangeHandlerPV(index)}
          id="project"
		   value={item.projectgroup_id} 
		   className="txtbox"
		  name="projectgroup_id"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.projectData.map(project => (
            <option  
            
              value={project.value}
            >
              {project.display}
            </option  >
          ))}
		
</Select></FormControl>)}
		
</TableCell> 





 </TableRow>
 
)}


 
 
				</React.Fragment>	
				);
					})}					  
					  
					  
					  
	 </TableBody>



</Table>
  </TableContainer> 
 
  </Paper>	
</div>



<div className="salesmodulecal">
<div className="first-col"><p>Notes</p><p>
 <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={this.state.vb_notes}
            id="vb_notes" multiline rows={3}         
            name="vb_notes" onChange={this.myChangeHandler}
            autoComplete="vb_notes"/>	 </p>

</div><div className="first-col"></div>
<div className="first-col"><p className="popformtext">Total</p><p className="popforminputs"><b>{this.state.grandtotal}</b> 
</p></div>

<div className="clear"></div>
<div className="first-col">
<Checkbox {...label} value={this.state.isdraft}  checked={this.state.isdraft }  onChange={this.handledraft} color="default" />  Save as draft<p>Draft Invoices do not update your Accounts</p>
</div>
<div className="clear"></div>
</div>



   
   <div className="salesactions">
   <p>
   <Button component="label"  className="frmSecondarybtn" name="vb_file"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<AttachmentIcon />}>
	
		Add File
		<VisuallyHiddenInput type="file"   /></Button>
		{this.state.previocn!="" && (
		<p><a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.previocn} target="_blank">View</a></p>
		)}
		
		&nbsp;
		
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>

   </div>
  
   <div className="clear"></div>
	

<Addproducts ref="Addproducts" prodid={0}  updateprodnew={this.updatProductParent}/>

</React.Fragment> 

		
		);
		
		

  }
}